import React from "react";
import styled from "styled-components";

const PaginationContainer = styled.div`
    display: flex;
    flex-flow: wrap;
    align-items: center;
    width: 100%;
    margin: 2rem 0;

    span {
        display: flex;
        flex-flow: wrap;
        align-items: center;
    }
`;

export default function Pagination({
    canPreviousPage,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    pageCount,
    pageIndex,
    gotoPage,
    pageSize,
    setPageSize
}) {
    return (
        <PaginationContainer>
            {(canNextPage || canPreviousPage) && (
                <>
                    <button
                        className="btn btn-icon btn-sm btn-light mr-2 my-1 btn-hover-primary"
                        onClick={() => gotoPage(0)}
                        disabled={!canPreviousPage}
                    >
                        <i className="ki ki-bold-double-arrow-back icon-xs"></i>
                    </button>
                    <button
                        className="btn btn-icon btn-sm btn-light mr-2 my-1 btn-hover-primary"
                        onClick={() => previousPage()}
                        disabled={!canPreviousPage}
                    >
                        <i className="ki ki-bold-arrow-back icon-xs"></i>
                    </button>
                    <button
                        className="btn btn-icon btn-sm btn-light mr-2 my-1 btn-hover-primary"
                        onClick={() => nextPage()}
                        disabled={!canNextPage}
                    >
                        <i className="ki ki-bold-arrow-next icon-xs"></i>
                    </button>
                    <button
                        className="btn btn-icon btn-sm btn-light mr-2 my-1 btn-hover-primary"
                        onClick={() => gotoPage(pageCount - 1)}
                        disabled={!canNextPage}
                    >
                        <i className="ki ki-bold-double-arrow-next icon-xs"></i>
                    </button>
                </>
            )}
            <div className="d-flex pt-2 pb-2">
                <span>
                    Page &nbsp;
                    <strong>
                        {pageIndex + 1} of {pageOptions.length}
                    </strong>{" "}
                    &nbsp;
                </span>
                {/* <span>
                    | Go: &nbsp;
                    <input
                        type="number"
                        defaultValue={pageIndex + 1}
                        onChange={e => {
                            const page = e.target.value
                                ? Number(e.target.value) - 1
                                : 0;
                            gotoPage(page);
                        }}
                        className="form-control form-control-sm font-weight-bold mr-4 border-0 bg-light false"
                        style={{ width: "50px", marginLeft: "5px" }}
                    />
                </span> */}
            </div>
            <select
                value={pageSize}
                onChange={e => {
                    setPageSize(Number(e.target.value));
                }}
                className="form-control form-control-sm font-weight-bold mr-4 border-0 bg-light false"
                style={{ width: "90px" }}
            >
                {[3, 5, 10, 20, 50, 100].map(pageSize => (
                    <option key={pageSize} value={pageSize}>
                        Show {pageSize}
                    </option>
                ))}
            </select>
        </PaginationContainer>
    );
}
